@if (gallery(); as gallery) {
  <div class="gallery-settings-container">
    <div class="gallery-settings-sidebar" *onlyForScreens="['desktop', 'tablet']">
      @if (gallery.teaser?.uuid) {
        <div class="gallery-asset" #el>
          <img
            [src]="gallery | galleryTeaserUrl: el.clientWidth"
            [style.object-position]="gallery.teaser.uuid === gallery.cover.uuid ? gallery.cover.position : undefined"
            alt=""
          />
          <div class="remove-teaser dark">
            <button
              appButton
              name="remove-teaser"
              location="gallery-settings-dialog"
              color="hard-simple"
              height="1"
              shape="round"
              [iconButton]="true"
              (click)="removeTeaser()"
            >
              <app-svg src="/assets/icons/trash.svg"></app-svg>
            </button>
          </div>
        </div>
      }
      @if (!gallery.teaser?.uuid) {
        <label class="gallery-asset empty" for="teaser-upload">
          <input
            type="file"
            id="teaser-upload"
            accept="image/*"
            class="hidden-input"
            (change)="uploadTeaserEvent($event.target)"
          />
          <app-svg src="/assets/icons/image-upload.svg"></app-svg>
        </label>
      }
      <div class="sidebar-menu">
        <button
          appButton
          name="access"
          location="gallery-settings-dialog"
          location="gallery-settings-dialog"
          color="simple"
          [class.bc-simple-primary.constant]="mode() === 'access'"
          (click)="mode.set('access')"
          [hasIcon]="true"
          shape="round"
          height="3"
          spacing="2-5"
          weight="bold"
          data-test-id="access"
        >
          <app-svg src="/assets/icons/gear.svg"></app-svg>
          <span>General</span>
        </button>
        <button
          appButton
          name="review"
          location="gallery-settings-dialog"
          color="simple"
          [class.bc-simple-primary.constant]="mode() === 'review'"
          (click)="mode.set('review')"
          [hasIcon]="true"
          data-test-id="review"
          shape="round"
          height="3"
          spacing="2-5"
          weight="bold"
          appNewFeature="gallery-settings-review"
        >
          <app-svg src="/assets/icons/bolt.svg"></app-svg>
          <span>Review</span>
          <app-new-feature-dot featureName="gallery-settings-review" position="inline"></app-new-feature-dot>
        </button>
        <button
          appButton
          name="design"
          location="gallery-settings-dialog"
          color="simple"
          [class.bc-simple-primary.constant]="mode() === 'design'"
          (click)="mode.set('design')"
          [hasIcon]="true"
          shape="round"
          height="3"
          spacing="2-5"
          weight="bold"
          data-test-id="design"
        >
          <app-svg src="/assets/icons/annotate-brush.svg"></app-svg>
          <span>Design</span>
        </button>
        <button
          appButton
          name="download"
          location="gallery-settings-dialog"
          color="simple"
          [class.bc-simple-primary.constant]="mode() === 'download'"
          (click)="mode.set('download')"
          [hasIcon]="true"
          shape="round"
          height="3"
          spacing="2-5"
          weight="bold"
          data-test-id="download"
        >
          <app-svg src="/assets/icons/download.svg"></app-svg>
          <span>Download</span>
        </button>
      </div>
      @if (galleryGuest() === false) {
        <div class="presets">
          <app-context-menu [options]="{ width: '280px', noSpacing: true }" #presetsMenu>
            <button
              appButton
              name="presets"
              location="gallery-settings-dialog"
              color="simple"
              [hasIcon]="true"
              height="2"
              spacing="2-5"
              shape="round"
              contextButton
              appTooltip="Choose Gallery Preset"
              data-test-id="presets"
            >
              <app-svg src="/assets/icons/toggle.svg"></app-svg>
              <span>{{ currentPreset() ? currentPreset().name : 'Custom' }}</span>
              <app-svg src="/assets/icons/12/chevron-down.svg" class="arrow-down"></app-svg>
            </button>
            <div contextContent>
              @if (presetsMenu.isOpen) {
                <app-gallery-settings-presets-context
                  [customPresets]="customPresets()"
                  [standardPresets]="standardPresets()"
                  [currentPreset]="currentPreset()"
                  [gallery]="gallery"
                  (close)="presetsMenu.close()"
                  (applyPreset)="applyPreset($event)"
                  (createPreset)="createPreset(); presetsMenu.close()"
                ></app-gallery-settings-presets-context>
              }
            </div>
          </app-context-menu>
        </div>
      }
    </div>
    <div class="gallery-settings-main-content">
      <div class="main-title-section">
        <ng-container *onlyForScreens="['desktop', 'tablet']">
          @if (mode() === 'access') {
            <h1>Gallery Settings</h1>
          } @else if (mode() === 'review') {
            <h1>Review & Feedback</h1>
          } @else if (mode() === 'download') {
            <h1>Download & Delivery</h1>
          } @else if (mode() === 'design') {
            <h1>Design</h1>
          }
        </ng-container>
        <ng-container *onlyForScreens="['mobile']">
          @if (mode() === 'access') {
            <h1>Settings</h1>
          } @else if (mode() === 'review') {
            <h1>Review</h1>
          } @else if (mode() === 'download') {
            <h1>Download</h1>
          } @else if (mode() === 'design') {
            <h1>Design</h1>
          }
        </ng-container>
        <button
          appButton
          name="share"
          location="gallery-settings-dialog"
          color="primary"
          weight="bold"
          spacing="4"
          height="4"
          size="3"
          shape="round"
          class="share-button"
          [hasIcon]="true"
          (click)="openShareDialog()"
          appTransitionPreventor
        >
          <app-svg src="/assets/icons/forward.svg"></app-svg>
          <span>Share</span>
        </button>
      </div>
      <div class="settings-container">
        @if (mode() === 'access') {
          @if (
            publicAccessLevel() === 'no_access' || (gallery.tenant || state.activeTenant)['block_public_link_access']
          ) {
            <div class="full-warning" (click)="openShareDialog()">
              <app-svg src="/assets/icons/stop.svg"></app-svg>
              <span>Only people added can access</span>
            </div>
          }
          <div
            [class.disabled-section]="
              gallery.public_access === 'no_access' ||
              (gallery.tenant || state.activeTenant)['block_public_link_access']
            "
          >
            <div class="settings-box-group">
              <app-action-box data-test-id="clientAdvancedMode">
                <app-action-box-icon icon="advanced-mode"></app-action-box-icon>
                <app-action-box-content
                  [small]="true"
                  title="Workflow View"
                  scope="gallery:client-advanced-mode"
                  [gallery]="gallery"
                >
                  Let visitors access workflow view.
                </app-action-box-content>
                <app-action-box-switch
                  [switchValue]="gallery.client_advanced_mode_enabled"
                  scope="gallery:client-advanced-mode"
                  [gallery]="gallery"
                  name="client-advanced-mode"
                  location="gallery-settings-dialog"
                  (onSwitch)="updateGallery({ client_advanced_mode_enabled: $event })"
                >
                </app-action-box-switch>
              </app-action-box>
            </div>
            <div class="settings-box-group">
              <app-action-box data-test-id="metadata">
                <app-action-box-icon icon="image-info"></app-action-box-icon>
                <app-action-box-content [small]="true" title="Metadata" [gallery]="gallery">
                  Display camera and EXIF information.
                </app-action-box-content>
                <app-action-box-switch
                  [switchValue]="gallery.save_camera_metadata"
                  [gallery]="gallery"
                  name="save-camera-metadata"
                  location="gallery-settings-dialog"
                  (onSwitch)="updateGallery({ save_camera_metadata: $event })"
                >
                </app-action-box-switch>
              </app-action-box>
              <app-action-box data-test-id="versionHistory">
                <app-action-box-icon icon="image-history"></app-action-box-icon>
                <app-action-box-content
                  [small]="true"
                  title="Version History"
                  scope="asset-version:multiple"
                  [gallery]="gallery"
                >
                  Let clients access older versions of assets.
                </app-action-box-content>
                <app-action-box-switch
                  [switchValue]="gallery.version_history_enabled"
                  scope="asset-version:multiple"
                  [gallery]="gallery"
                  name="version-history"
                  location="gallery-settings-dialog"
                  (onSwitch)="updateGallery({ version_history_enabled: $event })"
                >
                </app-action-box-switch>
              </app-action-box>
              <app-action-box data-test-id="watermark">
                <app-action-box-icon icon="image-watermark"></app-action-box-icon>
                <app-action-box-content
                  location="gallery-settings-dialog"
                  title="Watermark"
                  [small]="true"
                  scope="asset:watermarking"
                  [gallery]="gallery"
                >
                  Protect your assets with a watermark.
                </app-action-box-content>
                <app-action-box-switch
                  [switchValue]="watermarkOptionCheckedOverride() ?? !!gallery.watermark"
                  (onSwitch)="setWatermarking($event)"
                  [gallery]="gallery"
                  name="watermark"
                  location="gallery-settings-dialog"
                  [overridePermissionIfTrue]="true"
                  scope="asset:watermarking"
                  [disabled]="isWatermarkApplying()"
                >
                </app-action-box-switch>
                @if (watermarkOptionCheckedOverride() ?? !!gallery.watermark) {
                  <div class="action-box-below-content">
                    @if (!watermarks()?.length) {
                      <a
                        [routerLink]="'/a/settings/watermarks/create'"
                        appButton
                        spacing="3"
                        name="create-watermark"
                        location="gallery-settings-dialog"
                        color="primary"
                        >Create Watermark</a
                      >
                    } @else {
                      <div class="watermarking-selector-container">
                        <app-context-menu [options]="{ noSpacing: true, width: '280px' }" #watermarksMenu>
                          <button
                            appButton
                            name="gallery-watermark"
                            location="gallery-settings-dialog"
                            [hasIcon]="true"
                            class="watermark-select-button"
                            data-test-id="current-watermark"
                            [color]="!!(tempSelectedWatermark() || selectedWatermark()) ? 'default' : 'gray-bordered'"
                            contextButton
                          >
                            <span>{{ tempSelectedWatermark()?.name || selectedWatermark()?.name || 'Choose' }}</span>
                            <app-svg src="/assets/icons/chevron-down.svg" color="gray"></app-svg>
                          </button>
                          <div contextContent class="button-menu">
                            @for (watermark of watermarks(); track watermark) {
                              <app-button-menu-item
                                name="select-watermark"
                                location="gallery-settings-dialog"
                                data-test-id="select-watermark"
                                icon="watermark"
                                [color]="watermark === selectedWatermark() ? 'simple-primary' : 'simple'"
                                [weight]="watermark === selectedWatermark() ? 'bold' : 'normal'"
                                [fullWidth]="true"
                                (click)="tempSelectedWatermark.set(watermark)"
                                (onClick)="watermarksMenu.close()"
                              >
                                <span>{{ watermark.name }}</span>
                                @if (watermark === selectedWatermark()) {
                                  <app-svg src="/assets/icons/check.svg" post class="some-check"></app-svg>
                                }
                              </app-button-menu-item>
                            }
                            <div class="divider"></div>
                            <app-button-menu-item
                              name="select-watermark"
                              location="gallery-settings-dialog"
                              icon="gear"
                              [color]="'simple'"
                              [fullWidth]="true"
                              [routerLink]="'/a/settings/watermarks'"
                            >
                              <span>Manage Watermarks</span>
                            </app-button-menu-item>
                          </div>
                        </app-context-menu>
                        @if (tempSelectedWatermark() && tempSelectedWatermark().id !== gallery.watermark) {
                          <button
                            appButton
                            name="apply-watermark"
                            data-test-id="apply-watermark"
                            location="gallery-settings-dialog"
                            color="primary"
                            spacing="3"
                            (click)="applyWatermark(tempSelectedWatermark())"
                            [class.disabled]="isWatermarkApplying()"
                          >
                            Apply
                          </button>
                        }
                        @if (selectedWatermark() && selectedWatermark().id === gallery.watermark) {
                          <button
                            appButton
                            name="refresh-watermark"
                            location="gallery-settings-dialog"
                            color="primary"
                            spacing="3"
                            (click)="refreshWatermark()"
                            [class.disabled]="isWatermarkApplying()"
                          >
                            Update
                          </button>
                        }
                      </div>
                    }
                    @if (isWatermarkApplying()) {
                      <div class="watermark-applying-message" data-test-id="watermark-applying">
                        <app-loading-indicator [size]="'smaller'" [color]="'grey-50'"></app-loading-indicator>
                        <span>Applying watermarks.</span>
                      </div>
                    }
                  </div>
                }
              </app-action-box>
              <app-action-box data-test-id="identifyVisitors">
                <app-action-box-icon icon="contact-card"></app-action-box-icon>
                <app-action-box-content
                  [small]="true"
                  title="Identify Visitors"
                  scope="gallery:force-identification"
                  [gallery]="gallery"
                >
                  Require name and email to access this gallery.
                </app-action-box-content>
                <app-action-box-switch
                  [switchValue]="gallery.requires_user_identification"
                  scope="gallery:force-identification"
                  [gallery]="gallery"
                  name="require-identification"
                  location="gallery-settings-dialog"
                  (onSwitch)="updateGallery({ requires_user_identification: $event })"
                >
                </app-action-box-switch>
              </app-action-box>
            </div>
            @if (!gallery.section) {
              <div class="settings-box-group">
                <app-action-box>
                  <app-action-box-icon icon="browser-picflow"></app-action-box-icon>
                  <app-action-box-content
                    location="gallery-settings-dialog"
                    title="Show on Profile"
                    [small]="true"
                    [gallery]="gallery"
                  >
                    <div class="gallery-link-container">
                      <span>Add this gallery to your</span>
                      <a
                        href="https://{{ tenant()?.path }}.picflow.com"
                        target="_blank"
                        class="primary-link gallery-link"
                      >
                        <span>Picflow Profile</span>
                        <app-svg src="/assets/icons/16/arrow-external.svg"></app-svg>
                      </a>
                    </div>
                  </app-action-box-content>
                  <app-action-box-switch
                    [switchValue]="gallery.show_in_profile"
                    [gallery]="gallery"
                    name="show-in-profile"
                    location="gallery-settings-dialog"
                    (onSwitch)="updateGallery({ show_in_profile: $event })"
                  ></app-action-box-switch>
                </app-action-box>
              </div>
            }
          </div>
        }
        @if (mode() === 'review') {
          <div class="settings-box-group">
            <app-action-box data-test-id="feedback-gallery-status">
              <app-action-box-icon icon="gallery-image-check-hex"></app-action-box-icon>
              <app-action-box-content [small]="true" title="Gallery Status" [gallery]="gallery">
                Allow collaborators to update the gallery status.
              </app-action-box-content>
              <app-action-box-switch
                [switchValue]="gallery.enabled_gallery_statuses.length > 1"
                [gallery]="gallery"
                name="gallery-status"
                location="gallery-settings-dialog"
                (onSwitch)="saveGalleryStatus($event)"
              >
              </app-action-box-switch>
            </app-action-box>
            <app-action-box data-test-id="feedback-status">
              <app-action-box-icon [icon]="'image-check'"></app-action-box-icon>
              <app-action-box-content [small]="true" [title]="'Asset Status'" scope="asset:status" [gallery]="gallery">
                Enable approvals and other workflow states.
              </app-action-box-content>
              <app-action-box-switch
                [switchValue]="gallery.enabled_feedback_options.includes('status')"
                scope="asset:status"
                [gallery]="gallery"
                name="asset-status"
                location="gallery-settings-dialog"
                (onSwitch)="saveFeedbackOptions('status', $event)"
              >
              </app-action-box-switch>
              @if (gallery.enabled_feedback_options.includes('status')) {
                <div class="action-box-below-content">
                  <div class="multi-checkboxes">
                    <label class="approve-only-switch-parent" for="approve-only" data-test-id="approve-only">
                      <app-switch [small]="true">
                        <input
                          type="checkbox"
                          id="approve-only"
                          [(ngModel)]="approveOnly"
                          (ngModelChange)="onToggleApproveOnly(); reportCheck('approval-only', approveOnly())"
                        />
                        <label for="approve-only"></label>
                      </app-switch>
                      <span> Approve Only </span>
                      <app-svg
                        src="/assets/icons/16/info.svg"
                        class="approve-only-info-icon"
                        size="-1"
                        color="grey-50"
                        appTooltip="When enabled, a simple “Approve” button is shown."
                      ></app-svg>
                    </label>
                    <label class="approval-limit-switch-parent" for="approval-limits" data-test-id="approval-limit">
                      <app-switch [small]="true">
                        <input
                          type="checkbox"
                          id="approval-limits"
                          [(ngModel)]="showApprovalLimit"
                          (ngModelChange)="updateApprovalLimit(); reportCheck('approval-limit', showApprovalLimit())"
                          [disabled]="!('gallery:approval-limit' | billingScope) && !showApprovalLimit()"
                        />
                        <label for="approval-limits"></label>
                      </app-switch>
                      <div class="flex-badge">
                        <span>Approval Limit</span>
                        <app-upgrade-badge
                          location="gallery-settings-dialog"
                          scope="gallery:approval-limit"
                          [tenantId]="tenant()?.id"
                        ></app-upgrade-badge>
                      </div>
                    </label>
                  </div>
                  @if (showApprovalLimit()) {
                    <form [formGroup]="approvalLimitForm" class="approval-limit-form field-and-button">
                      <app-input-field
                        [control]="approvalLimitForm.controls.limit"
                        [noLabel]="true"
                        [smallNoLabel]="true"
                        [verySmallNoLabel]="true"
                        [noLabelExtraSpacing]="true"
                      >
                        <input
                          type="text"
                          placeholder="e.g. 24"
                          data-test-id="approval-limit-input"
                          formControlName="limit"
                        />
                      </app-input-field>
                      <div class="radio-box reversed">
                        <input
                          type="checkbox"
                          id="soft-limit"
                          formControlName="softLimit"
                          (change)="reportCheck('soft-limit', approvalLimitForm.value.softLimit)"
                        />
                        <label for="soft-limit">
                          <span class="soft-limit-text"
                            >Soft limit
                            <app-svg
                              class="info-icon"
                              src="/assets/icons/16/info.svg"
                              appTooltip="Allow additional approvals and
                                show a warning when the defined
                                amount is exceeded."
                            ></app-svg
                          ></span>
                        </label>
                      </div>
                    </form>
                  }
                </div>
              }
            </app-action-box>
          </div>
          <div class="settings-box-group">
            <app-action-box data-test-id="feedback-favourite">
              <app-action-box-icon icon="heart-image"></app-action-box-icon>
              <app-action-box-content [small]="true" title="Favorites" scope="asset:favourites" [gallery]="gallery">
                Allow visitors to favorite assets.
              </app-action-box-content>
              <app-action-box-switch
                [switchValue]="gallery.enabled_feedback_options.includes('favourite')"
                scope="asset:favourites"
                [gallery]="gallery"
                name="favorites"
                location="gallery-settings-dialog"
                (onSwitch)="saveFeedbackOptions('favourite', $event)"
              >
              </app-action-box-switch>
            </app-action-box>
            <app-action-box data-test-id="feedback-comment">
              <app-action-box-icon icon="comments"></app-action-box-icon>
              <app-action-box-content [small]="true" title="Comments" scope="asset:comments" [gallery]="gallery">
                Allow visitors to comment on assets
              </app-action-box-content>
              <app-action-box-switch
                [switchValue]="gallery.enabled_feedback_options.includes('comment')"
                scope="asset:comments"
                [gallery]="gallery"
                name="comments"
                location="gallery-settings-dialog"
                (onSwitch)="saveFeedbackOptions('comment', $event)"
              >
              </app-action-box-switch>
              @if (gallery.enabled_feedback_options.includes('comment') || annotationsEnabled()) {
                <div class="action-box-below-content">
                  <label class="annotations-switch-parent" for="annotations" data-test-id="feedback-annotation">
                    <app-switch [small]="true">
                      <input
                        type="checkbox"
                        id="annotations"
                        [(ngModel)]="annotationsEnabled"
                        (ngModelChange)="
                          saveFeedbackOptions('annotation', annotationsEnabled());
                          reportCheck('annotations', annotationsEnabled())
                        "
                      />
                      <label for="annotations"></label>
                    </app-switch>
                    <span> Annotations </span>
                  </label>
                </div>
              }
            </app-action-box>
            <app-action-box data-test-id="feedback-color_label">
              <app-action-box-icon icon="color-label"></app-action-box-icon>
              <app-action-box-content
                [small]="true"
                title="Color Labels"
                scope="asset:color-labels"
                [gallery]="gallery"
              >
                Let visitors mark assets with a color label.
              </app-action-box-content>
              <app-action-box-switch
                [switchValue]="gallery.enabled_feedback_options.includes('color_label')"
                scope="asset:color-labels"
                [gallery]="gallery"
                name="color-labels"
                location="gallery-settings-dialog"
                (onSwitch)="saveFeedbackOptions('color_label', $event)"
              >
              </app-action-box-switch>
              @if (gallery.enabled_feedback_options.includes('color_label')) {
                <div class="action-box-below-content">
                  <label class="custom-color-label-switch-parent" for="custom-color-labels">
                    <app-switch [small]="true">
                      <input
                        type="checkbox"
                        id="custom-color-labels"
                        [(ngModel)]="customColorLabels"
                        (ngModelChange)="onToggleCustomLabels(); reportCheck('color-labels', customColorLabels())"
                        [disabled]="!('asset:custom-labels' | billingScope) && !customColorLabels()"
                      />
                      <label for="custom-color-labels"></label>
                    </app-switch>
                    <div class="flex-badge">
                      Customize
                      <app-upgrade-badge
                        location="gallery-settings-dialog"
                        scope="asset:custom-labels"
                        [tenantId]="tenant()?.id"
                      ></app-upgrade-badge>
                    </div>
                  </label>
                  @if (customColorLabels()) {
                    <form [formGroup]="customLabelsForm" class="show-errors-without-submitting">
                      @for (label of gallery.color_labels; track label.color) {
                        <div class="custom-label">
                          <app-input-field
                            [control]="customLabelsForm.controls[label.color]"
                            class="headless"
                            [noLabel]="true"
                          >
                            <ng-container *onlyForScreens="['desktop', 'tablet']">
                              <div *appInputPre>
                                <app-svg
                                  src="/assets/icons/color-label-filled.svg"
                                  [attr.color]="label.active ? label.color : 'grey-50'"
                                >
                                </app-svg>
                              </div>
                            </ng-container>
                            <input
                              type="text"
                              [formControlName]="label.color"
                              [attr.color]="label.color"
                              [class.disabled]="!label.active"
                              (input)="saveCustomLabels()"
                            />
                            <button
                              appButton
                              name="toggle-custom-labels"
                              location="gallery-settings-dialog"
                              [color]="label.active ? 'simple-primary' : 'simple-gray'"
                              *appInputPost
                              [iconButton]="true"
                              (click)="label.active = !label.active; saveCustomLabels()"
                            >
                              @if (label.active) {
                                <app-svg src="/assets/icons/eye-open.svg"></app-svg>
                              } @else {
                                <app-svg src="/assets/icons/eye-strikethrough.svg"></app-svg>
                              }
                            </button>
                          </app-input-field>
                        </div>
                      }
                    </form>
                  } @else {
                    <div class="custom-labels-preview">
                      @for (label of gallery.color_labels; track label.color) {
                        <div class="color-{{ label.color }}">
                          <app-svg src="/assets/icons/color-label-filled.svg"></app-svg>
                          <span>{{ label.name }}</span>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </app-action-box>
          </div>
        }
        @if (mode() === 'design') {
          <div class="settings-box-group">
            <app-action-box data-test-id="gallery-background">
              <app-action-box-content
                location="gallery-settings-dialog"
                title="Gallery Background"
                [small]="true"
                [gallery]="gallery"
              >
                Color: {{ gallery.layout_background_color || '#FFFFFF' }}
              </app-action-box-content>
              <div action-box-cta>
                <app-context-menu
                  [options]="{ width: '272px', noSpacing: true }"
                  #backgroundColorMenu
                  [style.--gallery-background-color]="gallery.layout_background_color"
                  [class.dark-background]="gallery.layout_background_color | isDarkColor"
                >
                  <div class="background-selector" contextButton>
                    <div class="hoverlay"></div>
                    <app-svg src="/assets/icons/color-drop.svg"></app-svg>
                  </div>
                  <div contextContent class="color-picker-menu">
                    @if (backgroundColorMenu.isOpen) {
                      <app-color-selector
                        [(currentColor)]="gallery.layout_background_color"
                        (currentColorChange)="updateBackgroundColor($event)"
                        [gallery]="gallery"
                        [allowReset]="!!gallery.layout_background_color"
                      >
                      </app-color-selector>
                    }
                  </div>
                </app-context-menu>
              </div>
            </app-action-box>
            @if (growthBook.isOn('asset-bg-color')) {
              <app-action-box data-test-id="gallery-background">
                <app-action-box-content
                  location="gallery-settings-dialog"
                  title="Asset Background"
                  [small]="true"
                  [gallery]="gallery"
                >
                  Color: {{ gallery.asset_background_color || '#FFFFFF' }}
                </app-action-box-content>
                <div action-box-cta class="multi-button">
                  <app-switch [small]="true">
                    <input
                      type="checkbox"
                      name="asset-ambient-switch"
                      id="asset-ambient-switch"
                      [(ngModel)]="ambientMode"
                      (change)="updateGallery({ asset_ambient_mode: ambientMode() })"
                    />
                    <label for="asset-ambient-switch"></label>
                  </app-switch>

                  <app-context-menu
                    [options]="{ width: '272px', noSpacing: true }"
                    #backgroundColorMenu
                    [style.--gallery-background-color]="gallery.asset_background_color"
                    [class.dark-background]="gallery.asset_background_color | isDarkColor"
                  >
                    <div class="background-selector" contextButton>
                      <div class="hoverlay"></div>
                      <app-svg src="/assets/icons/color-drop.svg"></app-svg>
                    </div>
                    <div contextContent class="color-picker-menu">
                      @if (backgroundColorMenu.isOpen) {
                        <app-color-selector
                          [(currentColor)]="gallery.asset_background_color"
                          (currentColorChange)="updateAssetBackgroundColor($event)"
                          [gallery]="gallery"
                          [allowReset]="!!gallery.asset_background_color"
                        >
                        </app-color-selector>
                      }
                    </div>
                  </app-context-menu>
                </div>
              </app-action-box>
            }
          </div>
          <div class="settings-box-group">
            <app-action-box>
              <app-action-box-content
                location="gallery-settings-dialog"
                title="Titles"
                [small]="true"
                [gallery]="gallery"
              >
                Default Font:
                {{
                  gallery.default_title_typography.font_family ||
                    tenant()?.default_title_typography?.font_family ||
                    'Picflow Type'
                }}
              </app-action-box-content>
              <div action-box-cta class="multi-button">
                <app-context-menu [options]="{ width: '264px', noSpacing: true }">
                  <div
                    class="title-font-selector"
                    contextButton
                    [style.background-color]="gallery.layout_background_color"
                  >
                    <span
                      [style.fontFamily]="
                        (gallery.default_title_typography.font_family ||
                          tenant().default_title_typography?.font_family) + ', AkkuratLL'
                      "
                      [style.color]="
                        gallery.default_title_typography.font_color ||
                        ((gallery.layout_background_color | isDarkColor) ? '#FFFFFF' : '#1f232e')
                      "
                      >Aa</span
                    >
                  </div>
                  <div contextContent>
                    <app-font-selection-menu
                      [currentFont]="gallery.default_title_typography.font_family"
                      [defaultFont]="tenant().default_title_typography?.font_family"
                      (onSelected)="updateTitleFontFamily($event)"
                      [allowRemoveOverrides]="true"
                      (onRemoveoverrides)="onRemoveOverridesTitle()"
                    >
                    </app-font-selection-menu>
                  </div>
                </app-context-menu>
                <app-context-menu
                  [options]="{ width: '272px', noSpacing: true }"
                  #titleColorMenu
                  [style.--gallery-background-color]="
                    gallery.default_title_typography.font_color ||
                    ((gallery.layout_background_color | isDarkColor) ? '#FFFFFF' : '#1f232e')
                  "
                  [class.dark-background]="gallery.layout_background_color | isDarkColor"
                >
                  <div class="background-selector" contextButton>
                    <div class="hoverlay"></div>
                  </div>
                  <div contextContent class="color-picker-menu">
                    @if (titleColorMenu.isOpen) {
                      <app-color-selector
                        [(currentColor)]="gallery.default_title_typography.font_color"
                        (currentColorChange)="updateTitleFontColor($event)"
                        [gallery]="gallery"
                        [allowReset]="!!gallery.default_title_typography.font_color"
                      >
                      </app-color-selector>
                    }
                  </div>
                </app-context-menu>
              </div>
            </app-action-box>
            <app-action-box>
              <app-action-box-content
                location="gallery-settings-dialog"
                title="Paragraph"
                [small]="true"
                [gallery]="gallery"
              >
                Default Font:
                {{
                  gallery.default_paragraph_typography.font_family ||
                    tenant().default_paragraph_typography?.font_family ||
                    'Picflow Type'
                }}
              </app-action-box-content>
              <div action-box-cta class="multi-button">
                <app-context-menu [options]="{ width: '264px', noSpacing: true }">
                  <div
                    class="paragraph-font-selector"
                    [style.background-color]="gallery.layout_background_color"
                    contextButton
                  >
                    <span
                      [style.fontFamily]="
                        (gallery.default_paragraph_typography.font_family ||
                          tenant().default_paragraph_typography?.font_family) + ', AkkuratLL'
                      "
                      [style.color]="
                        gallery.default_paragraph_typography.font_color ||
                        ((gallery.layout_background_color | isDarkColor) ? '#FFFFFF' : '#5d6e82')
                      "
                      >Text</span
                    >
                  </div>
                  <div contextContent>
                    <app-font-selection-menu
                      [currentFont]="gallery.default_paragraph_typography.font_family"
                      [defaultFont]="tenant().default_paragraph_typography?.font_family"
                      (onSelected)="updateParagraphFontFamily($event)"
                      [allowRemoveOverrides]="true"
                      (onRemoveoverrides)="onRemoveOverridesParagraph()"
                    >
                    </app-font-selection-menu>
                  </div>
                </app-context-menu>
                <app-context-menu
                  [options]="{ width: '272px', noSpacing: true }"
                  #paragraphColorMenu
                  [style.--gallery-background-color]="
                    gallery.default_paragraph_typography.font_color ||
                    ((gallery.layout_background_color | isDarkColor) ? '#FFFFFF' : '#5d6e82')
                  "
                  [class.dark-background]="gallery.layout_background_color | isDarkColor"
                >
                  <div class="background-selector" contextButton>
                    <div class="hoverlay"></div>
                  </div>
                  <div contextContent class="color-picker-menu">
                    @if (paragraphColorMenu.isOpen) {
                      <app-color-selector
                        [(currentColor)]="gallery.default_paragraph_typography.font_color"
                        (currentColorChange)="updateParagraphFontColor($event)"
                        [gallery]="gallery"
                        [allowReset]="!!gallery.default_paragraph_typography.font_color"
                      >
                      </app-color-selector>
                    }
                  </div>
                </app-context-menu>
              </div>
            </app-action-box>
          </div>
        }
        @if (mode() === 'download') {
          <div class="settings-box-group">
            <app-action-box data-test-id="download-single">
              <app-action-box-icon icon="image-download"></app-action-box-icon>
              <app-action-box-content [small]="true" title="Asset Download" scope="asset:download" [gallery]="gallery">
                Allow individual asset downloads.
              </app-action-box-content>
              <app-action-box-switch
                [switchValue]="gallery.download_single_asset"
                scope="asset:download"
                [gallery]="gallery"
                name="asset-downloads"
                location="gallery-settings-dialog"
                (onSwitch)="updateGallery({ download_single_asset: $event })"
              >
              </app-action-box-switch>
            </app-action-box>
            <app-action-box data-test-id="download-gallery">
              <app-action-box-icon icon="image-stack-download"></app-action-box-icon>
              <app-action-box-content
                [small]="true"
                title="Gallery Download"
                scope="asset:download"
                [gallery]="gallery"
              >
                Allow ZIP downloads with all assets.
              </app-action-box-content>
              <app-action-box-switch
                [switchValue]="gallery.download_full_gallery"
                scope="asset:download"
                [gallery]="gallery"
                name="gallery-downloads"
                location="gallery-settings-dialog"
                (onSwitch)="updateGallery({ download_full_gallery: $event })"
              >
              </app-action-box-switch>
            </app-action-box>
          </div>

          <div class="settings-box-group">
            <app-action-box data-test-id="approved-downloads-only">
              <app-action-box-icon icon="check-download"></app-action-box-icon>
              <app-action-box-content
                [small]="true"
                title="Approved Only"
                scope="gallery:approved-downloads-only"
                [gallery]="gallery"
              >
                Allow only approved assets to be downloaded.
              </app-action-box-content>
              <app-action-box-switch
                [switchValue]="gallery.approved_downloads_only"
                scope="gallery:approved-downloads-only"
                [gallery]="gallery"
                name="approved-only"
                location="gallery-settings-dialog"
                (onSwitch)="updateGallery({ approved_downloads_only: $event })"
              >
              </app-action-box-switch>
            </app-action-box>

            <app-action-box data-test-id="download-size" [disabled]="downloadSizeDisabled()">
              <app-action-box-icon icon="size"></app-action-box-icon>
              <app-action-box-content
                location="gallery-settings-dialog"
                title="Image Sizes"
                [small]="true"
                [gallery]="gallery"
              >
                Select downloadable image sizes.
                @if (
                  gallery.watermark &&
                  enabledDownloadSizes().original &&
                  (gallery.download_single_asset || gallery.download_full_gallery)
                ) {
                  <div data-test-id="watermark-download-warning" class="original-warning-message">
                    <app-svg src="/assets/icons/16/alert.svg" size="-1"></app-svg>
                    <span>To allow original downloads, you need to hide the watermark on selected assets.</span>
                  </div>
                }
              </app-action-box-content>
              <app-context-menu [options]="{ noSpacing: true, width: '280px' }" action-box-cta>
                <app-action-box-button contextButton name="max-download-size" location="gallery-settings-dialog">
                  <button
                    appButton
                    name="max-download-size"
                    location="gallery-settings-dialog"
                    [hasIcon]="true"
                    class="download-size-button"
                  >
                    <span>{{ downloadSizeString() }}</span>
                    <app-svg src="/assets/icons/chevron-down.svg" color="gray"></app-svg>
                  </button>
                </app-action-box-button>
                <div contextContent class="button-menu">
                  @for (size of downloadSizes; track size) {
                    <app-radio-button
                      [checked]="enabledDownloadSizes()[size.name]"
                      (click)="toggleDownloadSize(size.name)"
                      name="toggle-download-size"
                      [analyticsExtra]="{ size: size.name, value: !enabledDownloadSizes()[size.name] }"
                      location="gallery-settings-dialog"
                    >
                      <span class="standard-text">
                        <b>{{ size.name | capitalize }}</b>
                        @if (size.size) {
                          <span> ({{ size.size }}px)</span>
                        }
                        @if (!size.size) {
                          <span> (Source Files)</span>
                        }
                      </span>
                    </app-radio-button>
                  }
                </div>
              </app-context-menu>
            </app-action-box>
          </div>
        }
        <div class="feedback">
          <p>
            Do you have feedback or suggestions?
            <a class="primary-link" [routerLink]="['/a/features']">Contact us</a>
          </p>
        </div>
      </div>
    </div>
  </div>
}
<app-sticky-footer
  [items]="menuItems"
  (onItemClick)="mode.set($event.key)"
  [selected]="mode()"
  *onlyForScreens="['mobile']"
>
  @if (galleryGuest() === false) {
    <div class="mobile-presets">
      <app-context-menu name="presets" [options]="{ width: '280px', noSpacing: true }" #presetsMenu>
        <button
          appButton
          name="presets"
          location="gallery-settings-dialog"
          color="simple"
          [hasIcon]="true"
          height="2"
          size="1"
          spacing="0"
          contextButton
          appTooltip="Choose Gallery Preset"
          data-test-id="mobile-presets"
          [verticalIcon]="true"
        >
          <app-svg src="/assets/icons/toggle.svg"></app-svg>
          <div class="mobile-presets-button-text">
            <span>{{ currentPreset() ? currentPreset().name : 'Custom' }}</span>
            <app-svg src="/assets/icons/12/chevron-down.svg" class="arrow-down"></app-svg>
          </div>
        </button>
        <div contextContent>
          @if (presetsMenu.isOpen) {
            <app-gallery-settings-presets-context
              [customPresets]="customPresets()"
              [standardPresets]="standardPresets()"
              [currentPreset]="currentPreset()"
              (onClose)="presetsMenu.close()"
              (applyPreset)="applyPreset($event)"
              (createPreset)="createPreset()"
            ></app-gallery-settings-presets-context>
          }
        </div>
      </app-context-menu>
    </div>
  }
</app-sticky-footer>
